import { render, staticRenderFns } from "./TagsTypeColumn.vue?vue&type=template&id=88200da8&scoped=true&"
import script from "./TagsTypeColumn.vue?vue&type=script&lang=js&"
export * from "./TagsTypeColumn.vue?vue&type=script&lang=js&"
import style0 from "./TagsTypeColumn.vue?vue&type=style&index=0&id=88200da8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88200da8",
  null
  
)

export default component.exports